/* eslint-disable */
const mutations = {
  updateIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },

  setData(state, data) {
    state.data = data;
  },
};

export default mutations;
